import { AdvancedSVG, EvolutionSVG, MlSpaceSVG, VmwareSVG } from '@sbercloud/uikit-product-icons';

import { PLATFORMS } from '@/constant/common';
import { equals } from '@/utils/common';

export function IconAllPlatforms() {
  return (
    <svg width='54' height='20' viewBox='0 0 54 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='path-1-outside-1_1927_43310'
        maskUnits='userSpaceOnUse'
        x='33'
        y='0'
        width='21'
        height='20'
        fill='black'
      >
        <rect fill='white' x='33' width='21' height='20' />
        <path d='M33 8C33 3.58172 36.5817 0 41 0H45C49.4183 0 53 3.58172 53 8V12C53 16.4183 49.4183 20 45 20H41C36.5817 20 33 16.4183 33 12V8Z' />
      </mask>
      <path
        d='M33 8C33 3.58172 36.5817 0 41 0H45C49.4183 0 53 3.58172 53 8V12C53 16.4183 49.4183 20 45 20H41C36.5817 20 33 16.4183 33 12V8Z'
        fill='white'
      />
      <path
        d='M33 0H53H33ZM53 20H33H53ZM33 20V0V20ZM45 0C49.9706 0 54 4.02944 54 9V11C54 15.9706 49.9706 20 45 20C48.866 20 52 16.4183 52 12V8C52 3.58172 48.866 0 45 0Z'
        fill='#DEDEDE'
        mask='url(#path-1-outside-1_1927_43310)'
      />
      <path
        d='M43.8359 7.81901C43.8359 7.08153 44.4893 6.15234 45.7239 6.15234C46.7953 6.15234 47.5859 7.00176 47.5859 7.81901M47.5859 7.81901V14.4857M47.5859 7.81901C47.5859 7.08153 48.2393 6.15234 49.4739 6.15234C50.5453 6.15234 51.3359 7.00176 51.3359 7.81901V14.4857'
        stroke='#389F74'
        strokeWidth='1.5'
      />
      <path
        d='M43.834 14.4854V7.67588C43.834 6.8508 43.132 6.15209 42.1673 6.15209C40.9173 6.15209 40.6184 7.32668 40.4576 7.67588L38.0006 13.8627H37.1673C37.1673 13.8627 35.0094 7.09846 34.8821 6.65735C34.7548 6.21623 34.6641 5.72238 34.6641 5.51367'
        stroke='#0A402C'
        strokeWidth='1.5'
      />
      <mask
        id='path-5-outside-2_1927_43310'
        maskUnits='userSpaceOnUse'
        x='22'
        y='0'
        width='21'
        height='20'
        fill='black'
      >
        <rect fill='white' x='22' width='21' height='20' />
        <path d='M22 8C22 3.58172 25.5817 0 30 0H34C38.4183 0 42 3.58172 42 8V12C42 16.4183 38.4183 20 34 20H30C25.5817 20 22 16.4183 22 12V8Z' />
      </mask>
      <path
        d='M22 8C22 3.58172 25.5817 0 30 0H34C38.4183 0 42 3.58172 42 8V12C42 16.4183 38.4183 20 34 20H30C25.5817 20 22 16.4183 22 12V8Z'
        fill='white'
      />
      <path
        d='M22 0H42H22ZM42 20H22H42ZM22 20V0V20ZM34 0C38.9706 0 43 4.02944 43 9V11C43 15.9706 38.9706 20 34 20C37.866 20 41 16.4183 41 12V8C41 3.58172 37.866 0 34 0Z'
        fill='#DEDEDE'
        mask='url(#path-5-outside-2_1927_43310)'
      />
      <path
        d='M34.7387 14.3767V5M34.7387 14.3767H39.5007V11.255M34.7387 14.3767H32.834M34.7387 5H36.6435M34.7387 5H32.834'
        stroke='#0A402C'
        strokeWidth='1.5'
      />
      <path d='M24.5 15V5H25.9286L27.3571 10.4545H28.3095L29.7381 5H31.1667V15' stroke='#389F74' strokeWidth='1.5' />
      <mask
        id='path-9-outside-3_1927_43310'
        maskUnits='userSpaceOnUse'
        x='11'
        y='0'
        width='21'
        height='20'
        fill='black'
      >
        <rect fill='white' x='11' width='21' height='20' />
        <path d='M11 8C11 3.58172 14.5817 0 19 0H23C27.4183 0 31 3.58172 31 8V12C31 16.4183 27.4183 20 23 20H19C14.5817 20 11 16.4183 11 12V8Z' />
      </mask>
      <path
        d='M11 8C11 3.58172 14.5817 0 19 0H23C27.4183 0 31 3.58172 31 8V12C31 16.4183 27.4183 20 23 20H19C14.5817 20 11 16.4183 11 12V8Z'
        fill='white'
      />
      <path
        d='M11 0H31H11ZM31 20H11H31ZM11 20V0V20ZM23 0C27.9706 0 32 4.02944 32 9V11C32 15.9706 27.9706 20 23 20C26.866 20 30 16.4183 30 12V8C30 3.58172 26.866 0 23 0Z'
        fill='#DEDEDE'
        mask='url(#path-9-outside-3_1927_43310)'
      />
      <path
        d='M24.7506 4.24098V12.083M17.2506 7.91634L17.2506 15.7558M21.0006 2.08301L27.8566 6.04134V13.958L21.0006 17.9163L14.1445 13.958V6.04134L21.0006 2.08301Z'
        stroke='#389F74'
        strokeWidth='1.5'
      />
      <path d='M20.166 9.16699H21.8327V10.8337H20.166V9.16699Z' fill='#0A402C' stroke='#0A402C' strokeWidth='1.5' />
      <mask
        id='path-13-outside-4_1927_43310'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='21'
        height='20'
        fill='black'
      >
        <rect fill='white' width='21' height='20' />
        <path d='M0 8C0 3.58172 3.58172 0 8 0H12C16.4183 0 20 3.58172 20 8V12C20 16.4183 16.4183 20 12 20H8C3.58172 20 0 16.4183 0 12V8Z' />
      </mask>
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H12C16.4183 0 20 3.58172 20 8V12C20 16.4183 16.4183 20 12 20H8C3.58172 20 0 16.4183 0 12V8Z'
        fill='white'
      />
      <path
        d='M0 0H20H0ZM20 20H0H20ZM0 20V0V20ZM12 0C16.9706 0 21 4.02944 21 9V11C21 15.9706 16.9706 20 12 20C15.866 20 19 16.4183 19 12V8C19 3.58172 15.866 0 12 0Z'
        fill='#DEDEDE'
        mask='url(#path-13-outside-4_1927_43310)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5ZM3.43751 8.12499L8.12503 3.4375C9.06253 2.49999 10.4688 2.03125 11.875 3.4375L16.5625 8.12499C17.5 9.06249 17.9688 10.4687 16.5625 11.875L11.875 16.5625C10.9375 17.5 9.33235 17.7698 8.12503 16.5625L3.43752 11.875C2.50004 10.9375 2.0313 9.53124 3.43751 8.12499Z'
        fill='#389F74'
        stroke='#389F74'
        strokeWidth='1.5'
      />
    </svg>
  );
}

export function IconEnDoc() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='16' viewBox='0 0 14 16' fill='none'>
      <path
        d='M6.99694 0.973633L13.0818 4.48671V9.26465H11.8818V5.17953L10.5969 4.43773V9.26465H9.39694V3.74491L6.99694 2.35927L2.11211 5.17953V10.82L3.39694 11.5618L3.39694 6.33312H4.59694V12.2547L6.99697 13.6403V15.026L0.912109 11.5129V4.48671L6.99694 0.973633Z'
        fill='#29CC6A'
      />
      <path d='M5.73145 6.7334H8.25879V9.26465H5.73145V6.7334Z' fill='#29CC6A' />
      <path
        d='M8.59863 10.0963L13.0873 10.0963V14.585H11.8873V12.1448L9.02302 15.0091L8.17449 14.1606L11.0388 11.2963H8.59863V10.0963Z'
        fill='#29CC6A'
      />
    </svg>
  );
}

export function PlatformIcon({ isLarge, platform }: { isLarge?: boolean; platform: string | null }) {
  if (!platform) return null;
  const platformIs = equals(platform);
  if (platformIs(PLATFORMS.evolution)) return <EvolutionSVG fill='#389F74' size={isLarge ? 30 : 20} />;
  if (platformIs(PLATFORMS.advanced)) return <AdvancedSVG fill='#389F74' size={isLarge ? 30 : 20} />;

  if (platformIs(PLATFORMS.vmware)) return <VmwareSVG fill='#389F74' size={isLarge ? 30 : 20} />;

  if (platformIs(PLATFORMS.mlSpace)) return <MlSpaceSVG fill='#389F74' size={isLarge ? 30 : 20} />;

  return null;
}
